<template>
    <div id="app">
        <!--  使用router-view组件进行路由管理 -->
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "App",
    };
</script>

<style>
    * {
        padding: 0;
        margin: 0;
        font-family: "Misrosoft YaHei";
        font-size: 16px;
    }
    html,
    body,
    #app {
        width: 100vw;
        height: 100vh;
    }
    #app {
        background: url(./assets/images/bg.png) no-repeat;
        background-size: cover;
    }
</style>
